import JSZip from "jszip";
export default class DownloadBilding {
  constructor(mesh, name) {
    this.name = name;
    this.downloadGLB(mesh, name.value);
  }

  async downloadGLB(mesh, name) {
    const buffer = await mesh.toBinaryGLTF({ origin: mesh.origin });

    this.downloadBufferAsFile(buffer, mesh.origin, name);
  }

  async downloadBufferAsFile(buffer, origin, name) {
    const zip = new JSZip();
    const data = this.attributs(origin, name);
    const csv = this.arrayToCSV(data);
    const glbContent = new Blob([buffer], { type: "model/gltf-binary" });

    const csvContent = new Blob([csv], { type: "text/csv" });
    // Add GLB file (binary data)
    zip.file("model.glb", glbContent);

    // Add CSV file (text)
    zip.file("data.csv", csvContent);

    // Generate the zip blob
    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Trigger download
    const url = URL.createObjectURL(zipBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = this.removeDiacriticsAndSpecialCharacters(this.name) + ".zip";
    a.click();
    URL.revokeObjectURL(url);
  }

  attributs(origin, name) {
    // Create attributs array

    const coordinates = [
      ["X", "Y", "Z", "name"],
      [origin.x, origin.y, origin.z, this.name],
    ];
    return coordinates;
  }

  arrayToCSV(dataArray) {
    // Convert array of arrays to CSV string
    return dataArray
      .map((row) => row.map((value) => `${value}`).join(","))
      .join("\n");
  }

  downloadCSV(csvContent, filename = "coordinates.csv") {
    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });

    // Create a link to download the file
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;

    // Simulate a click to download the file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  removeDiacriticsAndSpecialCharacters(str) {
    // Remove diacritics by converting accented characters to their base form

    const normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Remove all non-alphanumeric characters
    const cleanedStr = normalizedStr.replace(/[^a-zA-Z0-9]/g, "_");

    // Resource to lowercase
    return cleanedStr.toLowerCase();
  }
}
